import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import siiTheme from '@/themes/sii-theme';
import 'vuetify/dist/vuetify.min.css';
import i18n from '@/locales';
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify);

const opts = {
	theme: siiTheme,
	icons: {
		iconfont: 'md'
	},
	lang: {
		current: 'es',
		locales: { es },
	},
	theme: siiTheme
	// theme: {
 //  	themes: {
 //    	light: {
	// 			vessi: '#42b883',
	// 			bg: '#f2f3f7',
	// 			siiAzul: '#002b46',
	// 			siiNaranjo: '#fd461e',
	// 			siiPrimary: '#0162a0',
	// 			background: '#f2f3f7'
 //    	},
 //    	dark: {
 //      	vessi: '#42b883',
 //      	bg: '#f2f3f7',
 //      	siiAzul: '#002b46',
 //      	siiNaranjo: '#fd461e',
 //      	siiPrimary: '#0162a0',
 //      	background: '#f2f3f7'
 //    	}
 //  	}
	// }
};

Vue.use(Vuetify);

// export default new Vuetify(opts);

// Aplicarlos a Vuetify
export default new Vuetify(opts);
